import {
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  OnInit,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { IPartner } from 'src/app/domain/registration/models/IPartner';

@Component({
  selector: 'app-business-hours',
  templateUrl: './business-hours.component.html',
  styleUrls: ['./business-hours.component.sass'],
})
export class BusinessHoursComponent implements OnInit {
  public daysOfWeek = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ];
  config: IFieldConfig[];
  form: FormGroup;
  typeCes?: TypeCesEnum | undefined;
  isExpanded: boolean = false;

  get typeCesEnum() {
    return TypeCesEnum;
  }

  constructor(
    public dialogRef: MatDialogRef<BusinessHoursComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: {
      config: IFieldConfig[];
      formGroup: FormGroup;
      typeCes: TypeCesEnum;
    },
    private cdr: ChangeDetectorRef
  ) {
    this.config = data.config;
    this.form = data.formGroup;
    this.typeCes = data.typeCes;
  }

  ngOnInit(): void {
    this.loadBusinessHourFields();
    this.formListener();
  }

  public getFieldConfig(name: string): any {
    return this.config.find((c) => c.name === name);
  }

  loadBusinessHourFields() {
    [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ].forEach((day) => {
      this.setDisabled(
        `start${day}BusinessHour`,
        !this.form.get(`check${day}BusinessHour`)?.getRawValue() || this.typeCes === TypeCesEnum.SHOW
      );
      this.setDisabled(
        `end${day}BusinessHour`,
        !this.form.get(`check${day}BusinessHour`)?.getRawValue()  || this.typeCes === TypeCesEnum.SHOW
      );
    });
  }

  formListener() {
    [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ].forEach((day) => {
      this.form.get(`check${day}BusinessHour`)?.valueChanges.subscribe((x) => {
        this.setDisabled(`start${day}BusinessHour`, !x);
        this.setDisabled(`end${day}BusinessHour`, !x);
      });
    });
  }

  setDisabled(field: string, value = false) {
    if (value) {
      this.form.controls[field].disable();
    } else {
      this.form.controls[field].enable();
    }
  }

  ok() {
    this.dialogRef.close({ element: this.form.value });
  }

  close() {
    this.dialogRef.close();
  }
}
